<template>
  <div class="avecor-table" style="position:fixed; bottom:0px; z-index:100; background:#eee; border:1px solid #ccc; height:500px;">
    <div style="position:absolute; left:10px; top:10px; z-index:100;">
      <v-icon 
        class="avecor-table-actions"
        :size="16"
        style="padding-right:10px; color:#000;"
        @click="selectedCompanyId = null"
      >
        far fa-window-close
      </v-icon>
    </div>
    <div style="overflow-y:auto; max-height:100%; min-height:350px; border-top: 2px solid #ddd;" v-if="companies[selectedCompanyId]">
      <v-row no-gutters justify-center class="pt-2 pb-2">
        <v-col sm="12" class="text-center" style="font-size:24px;">
          {{companies[selectedCompanyId] ? companies[selectedCompanyId].companyName : ''}}
          <span style="font-size:12px;" class="pl-3">
            <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" >
                  <v-icon 
                    :size="16"
                    style="padding-left:10px;padding-right:5px;padding-bottom:10px;"
                    @click="syncCompanyToNetvisor(selectedCompanyId,'production')"
                  >
                    fas fa-exchange-alt
                  </v-icon>
                </span>
              </template>
              <div style="font-size:11px;background:#FFF;padding:10px;">
                <div>Synkronoi yritys Netvisorin tuotantoympäristöön.</div>
              </div>
            </v-menu>
            <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" >
                  <v-icon 
                    :size="16"
                    color="red"
                    style="padding-left:10px;padding-right:5px;padding-bottom:10px;"
                    @click="syncCompanyToNetvisor(selectedCompanyId,'development')"
                  >
                    fas fa-exchange-alt
                  </v-icon>
                </span>
              </template>
              <div style="font-size:11px;background:#FFF;padding:10px;">
                <div>Synkronoi yritys Netvisorin testiympäristöön.</div>
              </div>
            </v-menu>
          </span>
          <span style="font-size:12px;" class="pl-3">
            <a v-if="companies[selectedCompanyId] && companies[selectedCompanyId].netvisorKey" target="_blank" :href="'https://suomi.netvisor.fi/evo/accounting/salesledger/customer/customerview.aspx?customerid='+companies[selectedCompanyId].netvisorKey" >Yritys Netvisorissa</a>
            <a v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' && companies[selectedCompanyId] && companies[selectedCompanyId].netvisorKey_test_env" style="color:red" class="pl-2" target="_blank" :href="'https://koulutus.netvisor.fi/evo/accounting/salesledger/customer/customerview.aspx?customerid='+companies[selectedCompanyId].netvisorKey_test_env" >Netvisor test linkki</a>
          </span>
        </v-col>
      </v-row>
      <v-tabs
        style="padding-top:0px;"
        fixed-tabs
        background-color="#F26539"
        dark
        dense
        height="30"
        v-model="selectedCompanyTab"
      >
        <v-tabs-slider color="#FFF"></v-tabs-slider>
        <v-tab href="#companyInfo" >Yrityksen tiedot</v-tab>
        <v-tab href="#contacts" >Kontaktit</v-tab>
        <v-tab href="#files">Tiedostot</v-tab>
        <v-tab href="#orders">Tilaukset</v-tab>
        <v-tab href="#billingAddresses" v-if="companies[selectedCompanyId].isShop">Shop - Laskutusosoitteet</v-tab>
        <v-tab href="#deliveryAddresses"  v-if="companies[selectedCompanyId].isShop">Shop - Toimitusosoitteet</v-tab>
        <v-tab-item value="files">
          <v-row no-gutters>
              <v-col sm="6"></v-col>
              <v-col sm="6"></v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item value="companyInfo" class="avecor-table">
          <CompanyInfo :companyId="selectedCompanyId" />
        </v-tab-item>
        <v-tab-item value="contacts" class="avecor-table">
          <CompanyContactsTable :companyId="selectedCompanyId" />
        </v-tab-item>
        <v-tab-item value="files" class="avecor-table" style="background-color:#eee">
          <v-row no-gutters style="border:1px dotted #ccc;" class="pt-5 pb-5">
            <v-col sm="4">
              <h3  class="text-center">Yrityksen logot</h3>
              <MediaGrid :types="['logo']" :actions="['delete','copyUrl','download']" :company="companies[selectedCompanyId]"></MediaGrid>
            </v-col>
            <v-col sm="4" style="border-left: 1px solid #ccc ">
              <h3  class="text-center">Lisää logo yritykselle</h3>
              <MediaUpload type="logo" :companyId="selectedCompanyId"  />
            </v-col>
            <v-col sm="4" style="border-left: 1px solid #ccc ">
              <h3  class="text-center">Yrityksen vedokset</h3>
              <MediaGrid :types="['draft']" :actions="['delete','copyUrl','download']" colsPerItem="2" :company="companies[selectedCompanyId]" ></MediaGrid>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item value="orders" class="avecor-table">
          <CompanyOrdersTable :companyId="selectedCompanyId"/>
        </v-tab-item>
        <v-tab-item value="billingAddresses" class="avecor-table">
          <CompanyShopAddresses :companyId="selectedCompanyId" whichAddresses="billing"/>
        </v-tab-item>
        <v-tab-item value="deliveryAddresses" class="avecor-table">
          <CompanyShopAddresses :companyId="selectedCompanyId" whichAddresses="delivery"/>
        </v-tab-item>
      </v-tabs>
     </div>
     <div v-else style="height:300px;padding-top:150px;padding-left:100px;" >
      <span>Tämä yritys on poistettu</span>

     </div>
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import firebase from 'firebase'
import CompanyOrdersTable from './CompanyOrdersTable.vue'
import CompanyShopAddresses from './CompanyShopAddresses.vue'
import CompanyInfo from './CompanyInfo.vue'
import CompanyContactsTable from './CompanyContactsTable'



export default {
    props: ['location'],
    components: {
      CompanyOrdersTable,
      CompanyInfo,
      CompanyContactsTable,
      CompanyShopAddresses
    },
    data: () => ({
      table: null,
      selectedCompanyTab:"companyInfo",
      expanded: [],
      results:{},
      promotionContacts:[],
      singleExpand: true,
      headers: [
        { text: ' ', value: 'name', align: 'center', sortable: false },
        { text: 'Kontaktin Nimi', value: 'name', align: 'left', sortable: false},
        { text: 'Lähetykset', value: 'name', align: 'left', sortable: false},
        { text: 'Avaukset', value: 'name', align: 'left', sortable: false},
        { text: 'Klikit', value: 'name', align: 'left', sortable: false},
      ],
    }),
    mounted() {
      

    },
    computed: {
      ...mapFields({
        settings:"settings",
        user:"user",
        device:"device",
        staff:"staff.staff",
        contacts:"contact.contacts",
        companies:"company.companies",
        selectedCompanyIdInCompanies:"views.companies.selectedCompany.companyId",
        selectedCompanyIdInOrders:"views.orders.selectedCompany.companyId",
        selectedCompanyIdInShops:"views.shops.selectedCompany.companyId",
      }),
      selectedCompanyId:{
        get: function () {
          if(this.location === 'orders') return this.selectedCompanyIdInOrders
          else if(this.location === 'companies') return this.selectedCompanyIdInCompanies
          else if(this.location === 'shops') return this.selectedCompanyIdInShops
        },
        set: function (newValue) {
          if(this.location === 'orders') this.selectedCompanyIdInOrders = newValue
          else if(this.location === 'companies') this.selectedCompanyIdInCompanies = newValue
          else if(this.location === 'shops') this.selectedCompanyIdInShops = newValue
        }
      },
    },

    watch: {
      
    },
    created () {},
    methods: {
      async syncCompanyToNetvisor(companyId,env){
        try{
          await this.$store.dispatch('syncCompanyToNetvisor', {companyId,env})
        }
        catch(e){
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:e, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd HH:MM")
        }
        return ''
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Id kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      sortResultsByDate(){
        var resultsTemp = {}
        var t = this
        Object.keys(this.results).forEach(key => {
          var sortedEvents = t.results[key].sort(function(a,b){
            var aDate = a.created_at.seconds
            var bDate = b.created_at.seconds
            return new Date(bDate) - new Date(aDate);
          });
          resultsTemp[key] = sortedEvents
        })
        this.results = resultsTemp
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/CompanyExpand.vue